module.exports = __webpack_public_path__ + "static/media/allergen_soya.b975538d.b975538d.png";